  <div
    class="alert alert-info d-flex align-items-center justify-content-between mb-2"
    role="alert"
  >
    <div class="d-flex align-items-center">
      <span> {{ bannerText() | translate }} </span>
    </div>
    <app-actions-group [model]="model()"
                       [actionsGroupName]="actionsGroupName()"
    />
  </div>
